export default function ProductIntroduction({ description }) {
  return (
    <p className="mt-[16px] px-[10px] text-[14px]" style={{ textIndent: '2em' }}>
      {description}
    </p>
  );
}
